<template>
    <div>
        <div class="d-flex flex-column-fluid">
            <!--begin::Container-->
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-lg-12 col-xl-12">
                                <div class="card card-custom gutter-b bg-transparent shadow-none border-0">
                                    <div class="card-header align-items-center  border-bottom-dark px-0">
                                        <div class="card-title mb-0">
                                            <h3 class="card-label mb-0 font-weight-bold text-body">
                                             Product Options
                                        </h3>
                                        </div>
                                        <div class="icons d-flex">
                                            <button class="btn ml-2 p-0 kt_notes_panel_toggle" data-toggle="tooltip"
                                                title="" data-placement="right" data-original-title="Check out more demos"
                                                v-if="$parent.permissions.includes('product-opinion-manage')">
                                                <span
                                                    class="bg-secondary h-30px font-size-h5 w-30px d-flex align-items-center justify-content-center  rounded-circle shadow-sm "
                                                    v-on:click="
                                                        display_form = !display_form;
                                                    model_name = 'Add Options'
                                                        ">
                                                    <svg width="25px" height="25px" viewBox="0 0 16 16"
                                                        class="bi bi-plus white" fill="currentColor"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <path fill-rule="evenodd"
                                                            d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z">
                                                        </path>
                                                    </svg>
                                                </span>
                                            </button>
                                            <!-- <a href="javascript:void(0)" onclick="printDiv()" class="ml-2">
                                            <span class="icon h-30px font-size-h5 w-30px d-flex align-items-center justify-content-center rounded-circle ">
                                                <svg width="15px" height="15px" viewBox="0 0 16 16" class="bi bi-printer-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M5 1a2 2 0 0 0-2 2v1h10V3a2 2 0 0 0-2-2H5z"></path>
                                                    <path fill-rule="evenodd" d="M11 9H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1z"></path>
                                                    <path fill-rule="evenodd" d="M0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2H2a2 2 0 0 1-2-2V7zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"></path>
                                                </svg>
                                            </span>
                                        </a>
                                        <a href="javascript:void(0)" class="ml-2">
                                            <span class="icon h-30px font-size-h5 w-30px d-flex align-items-center justify-content-center rounded-circle ">
                                                <svg width="15px" height="15px" viewBox="0 0 16 16" class="bi bi-file-earmark-text-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" d="M2 2a2 2 0 0 1 2-2h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm7 2l.5-2.5 3 3L10 5a1 1 0 0 1-1-1zM4.5 8a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7zM4 10.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5z"></path>
                                                </svg>
                                            </span>
                                        </a> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 ">
                                <div class="card card-custom gutter-b bg-white border-0">
                                    <div class="card-body">
                                        <div>
                                            <div class=" table-responsive" id="printableTable">

                                                <div id="productopinionTable_wrapper" class="dataTables_wrapper no-footer">

                                                    <div class="dataTables_length" id="productopinionTable_length">
                                                        <label>Show
                                                            <select name="productopinionTable_length" class=""
                                                                v-model="limit" v-on:change="fetchopinions()">
                                                                <option value="10">10</option>
                                                                <option value="25">25</option>
                                                                <option value="50">50</option>
                                                                <option value="100">100</option>
                                                                <option value="200">200</option>
                                                                <option value="500">500</option>
                                                                <option value="1000">1000</option>
                                                            </select> entries</label></div>

                                                    <div id="productopinionTable_filter" class="dataTables_filter">
                                                        <label>
                                                            Search:<input type="text" class="" placeholder=""
                                                                v-model="searchParameter" @keyup="fetchopinions()">
                                                        </label>
                                                        <button style="padding: 0.375rem 0.75rem !important;"
                                                            class="btn btn-light  font-weight-bold mr-1 mb-1"
                                                            v-if="this.searchParameter != ''" @click="clearSearch"> Clear
                                                        </button>


                                                    </div>
                                                    <table id="productopinionTable" class="display dataTable no-footer"
                                                        role="grid">
                                                        <thead class="text-body">
                                                            <tr role="row">
                                                                <th class="sorting" tabindex="0" rowspan="1" colspan="1"
                                                                    aria-sort="ascending"
                                                                    aria-label="ID: activate to sort column descending"
                                                                    style="width: 31.25px;" @click="sorting('id')"
                                                                    :class="(this.$data.sortType == 'asc' || this.$data.sortType == 'ASC') && this.$data.sortBy == 'id' ? 'sorting_asc' : (this.$data.sortType == 'desc' || this.$data.sortType == 'DESC') && this.$data.sortBy == 'id' ? 'sorting_desc' : 'sorting'">
                                                                    ID
                                                                </th>
                                                                <th class="sorting" tabindex="0" rowspan="1" colspan="1"
                                                                    aria-label="opinion: activate to sort column ascending"
                                                                    style="width: 95.5288px;" @click="sorting('name')"
                                                                    :class="(this.$data.sortType == 'asc' || this.$data.sortType == 'ASC') && this.$data.sortBy == 'name' ? 'sorting_asc' : (this.$data.sortType == 'desc' || this.$data.sortType == 'DESC') && this.$data.sortBy == 'name' ? 'sorting_desc' : 'sorting'">
                                                                    Name
                                                                </th>
                                                                <th v-if="$parent.permissions.includes('product-opinion-manage')"
                                                                    class="no-sort sorting_disabled" rowspan="1" colspan="1"
                                                                    aria-label="Action" style="width: 53.1891px;">
                                                                    Action
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody class="kt-table-tbody text-dark">
                                                            <tr class="kt-table-row kt-table-row-level-0 odd" role="row"
                                                                v-for="opinion in opinions" :key="opinion.opinion_id">
                                                                <td class="sorting_1">
                                                                    {{ opinion.opinion_id }}
                                                                </td>
                                                                <td>
                                                                    {{ opinion.detail == null ? '' : (opinion.detail[0] ?
                                                                        opinion.detail[0].name : '') }}
                                                                </td>
                                                                <td
                                                                    v-if="$parent.permissions.includes('product-opinion-manage')">
                                                                    <a href="javascript:void(0)" class=" click-edit"
                                                                        id="click-edit1" data-toggle="tooltip" title=""
                                                                        data-placement="right"
                                                                        data-original-title="Check out more demos"
                                                                        @click="editopinion(opinion)"><i
                                                                            class="fa fa-edit"></i></a>
                                                                    <a class="" href="javascript:void(0)"
                                                                        @click="deleteopinion(opinion.opinion_id)"><i
                                                                            class="fa fa-trash"></i></a>
                                                                </td>

                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <ul class="pagination pagination-sm m-0 float-right">
                                                        <li v-bind:class="[{ disabled: !pagination.prev_page_url }]"><button
                                                                class="page-link" href="javascript:void(0)"
                                                                @click="fetchopinions(pagination.prev_page_url)">Previous</button>
                                                        </li>

                                                        <li class="disabled"><button class="page-link text-dark"
                                                                href="javascript:void(0)">Page {{ pagination.current_page }}
                                                                of {{ pagination.last_page }}</button></li>

                                                        <li v-bind:class="[{ disabled: !pagination.next_page_url }]"
                                                            class="page-item"><button class="page-link"
                                                                href="javascript:void(0)"
                                                                @click="fetchopinions(pagination.next_page_url)">Next</button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="offcanvas offcanvas-right kt-color-panel p-5 kt_notes_panel" v-if="display_form"
            :class="display_form ? 'offcanvas-on' : ''">
            <div class="offcanvas-header d-flex align-items-center justify-content-between pb-3">
                <h4 class="font-size-h4 font-weight-bold m-0">{{ model_name }}</h4>
                <a href="javascript:void(0)" class="btn btn-sm btn-icon btn-light btn-hover-primary kt_notes_panel_close"
                    v-on:click="clearForm()">
                    <svg width="20px" height="20px" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor"
                        xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd"
                            d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z">
                        </path>
                    </svg>
                </a>
            </div>
            <form id="myform">
                <div class="row">
                    <div class="col-12">
                        <div class="tabslang">
                            <div v-for="language in languages" class="tablang"
                                :class="language.id == selectedLanguage ? 'active' : ''"
                                @click="setSelectedLanguage(language.id)">
                                {{ language.language_name }}
                            </div>
                        </div>
                        <div class="form-group " v-for="(language, index) in languages"
                            v-if="language.id == selectedLanguage">
                            <label class="text-dark">Name ( {{ language.language_name }} ) </label>
                            <input type="text" :name="'name' + index" v-model="opinion.name[index]" class="form-control" />
                            <small class="form-text text-danger" v-if="errors.has('name')"
                                v-text="errors.get('name')"></small>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form-group ">
                            <SwitchButton title="Show benefit"
                                name="show_benefit"
                                :value="opinion.show_benefit"
                                @updateValue="updateValue"
                            />
                        </div>
                        <small class="form-text text-danger" v-if="errors.has('show_benefit')"
                            v-text="errors.get('show_benefit')"></small>
                    </div>
                    <div class="col-12">
                        <div class="form-group ">
                            <SwitchButton title="Show editor"
                                name="show_editor"
                                :value="opinion.show_editor"
                                @updateValue="updateValue"
                            />
                        </div>
                        <small class="form-text text-danger" v-if="errors.has('show_editor')"
                            v-text="errors.get('show_editor')"></small>
                    </div>
                    <div class="col-12">
                        <div class="form-group ">
                            <SwitchButton title="Show Gallary Description"
                                name="show_gallary_description"
                                :value="opinion.show_gallary_description"
                                @updateValue="updateValue"
                            />
                        </div>
                        <small class="form-text text-danger" v-if="errors.has('show_gallary_description')"
                            v-text="errors.get('show_gallary_description')"></small>
                    </div>
                    <div class="col-12">
                        <div class="form-group ">
                            <SwitchButton title="Full Width Gallary"
                                name="full_width_gallary"
                                :value="opinion.full_width_gallary"
                                @updateValue="updateValue"
                            />
                        </div>
                        <small class="form-text text-danger" v-if="errors.has('full_width_gallary')"
                            v-text="errors.get('full_width_gallary')"></small>
                    </div>

                </div>
                <button type="button" @click="addUpdateopinion()" class="btn btn-primary">Submit</button>
            </form>
        </div>
    </div>
</template>

<script>
import ErrorHandling from "./../../ErrorHandling";
import SwitchButton from './partials/SwitchButton.vue';
export default {
  components: { SwitchButton },
    data() {
        return {
            display_form: 0,
            opinion: {
                opinion_id: "",
                name: [],
                language_id: [],
                show_benefit: 0,
                show_editor: 0,
                show_gallary_description:0,
                full_width_gallary:0
            },
            model_name: "Edit Opinion",
            searchParameter: '',
            sortBy: 'id',
            sortType: 'ASC',
            limit: 10,
            error_message: '',
            edit: false,
            actions: false,
            pagination: {},
            request_method: "",
            countrySelected: "",
            stateSelected: "",
            opinions: [],
            languages: [],
            token: [],
            selectedLanguage: '',
            errors: new ErrorHandling(),
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute("content")
        };
    },

    methods: {
        updateValue(value, name) {
            this.opinion[name] = value;
        },
        fetchLanguages() {
            this.$parent.loading = true;
            var token = localStorage.getItem('token');
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            };
            var responseData = {};

            axios.get('/api/admin/language?limit=500', config)
                .then(res => {
                    if (res.data.status == "Success") {
                        this.languages = res.data.data;
                        for (var i = 0; i < res.data.data.length; i++) {
                            this.opinion.language_id.push(res.data.data[i].id);
                            if (res.data.data[i].is_default) {
                                this.selectedLanguage = res.data.data[i].id;
                            }
                        }
                    }
                }).finally(() => (this.$parent.loading = false));
        },
        fetchopinions(page_url) {
            this.$parent.loading = true;
            let vm = this;
            page_url = page_url || "/api/admin/opinion";
            var arr = page_url.split('?');

            if (arr.length > 1) {
                page_url += '&limit=' + this.limit;
            }
            else {
                page_url += '?limit=' + this.limit;
            }
            if (this.searchParameter != null) {
                page_url += '&searchParameter=' + this.searchParameter;
            }
            page_url += '&sortBy=' + this.sortBy + '&sortType=' + this.sortType + '&getDetail=1';
            var responseData = {};

            axios.get(page_url, this.token).then(res => {
                this.opinions = res.data.data;
                vm.makePagination(res.data.meta, res.data.links);
            }).finally(() => (this.$parent.loading = false));
        },

        makePagination(meta, links) {
            let pagination = {
                current_page: meta.current_page,
                last_page: meta.last_page,
                next_page_url: links.next,
                prev_page_url: links.prev
            };

            this.pagination = pagination;
        },
        deleteopinion(id) {
            if (confirm('Are You Sure?')) {
                this.$parent.loading = true;
                axios.delete(`/api/admin/opinion/${id}`, this.token)
                    .then(res => {
                        if (res.data.status == "Success") {
                            this.$toaster.success('Product Opinion has been Delete successfully')
                            this.fetchopinions();
                        }

                    })
                    .catch(error => {
                        if (error.response.status == 422) {
                            if (error.response.data.status == 'Error') {
                                this.$toaster.error(error.response.data.message)
                            }
                        }
                    })
                    .finally(() => (this.$parent.loading = false));
            }
        },
        addUpdateopinion() {
            this.$parent.loading = true;
            var url = '/api/admin/opinion';
            if (this.edit === false) {
                // Add
                this.request_method = 'post'
            } else {
                // Update
                var url = '/api/admin/opinion/' + this.opinion.opinion_id;
                this.request_method = 'put'
            }
            axios[this.request_method](url, this.opinion, this.token)
                .then(res => {
                    if (res.data.status == "Success") {
                        this.display_form = 0;
                        this.$toaster.success('Product Opinion has been updated successfully')
                        this.clearForm();
                        this.fetchopinions();
                    } else {
                        this.$toaster.error(res.data.message)
                    }
                })
                .catch(error => {
                    this.error_message = '';
                    this.errors = new ErrorHandling();
                    if (error.response.status == 422) {
                        if (error.response.data.status == 'Error') {
                            this.error_message = error.response.data.message;
                        }
                        else {
                            this.errors.record(error.response.data.errors);
                        }
                    }
                }).finally(() => (this.$parent.loading = false));

        },
        editopinion(opinion) {
            this.model_name = "Edit Opinion";
            this.edit = true;
            this.display_form = 1;
            this.errors = new ErrorHandling();
            this.opinion.opinion_id = opinion.opinion_id;
            this.opinion.name = [];
            this.$parent.loading = true;
            axios.get(`/api/admin/opinion/${opinion.opinion_id}?getDetail=1`, this.token)
                .then(res => {
                    if (res.data.status == "Success") {
                        res.data.data.detail.forEach(u => {
                            // this.attribute.name.push(u.name);
                            this.opinion.name[this.opinion.language_id.indexOf(u.language.id)] = u.name;
                        });
                        this.opinion = Object.assign({}, this.opinion, {
                        opinion_id: Number(opinion.opinion_id),
                        show_benefit: Number(res.data.data.show_benefit),
                        show_editor: Number(res.data.data.show_editor),
                        show_gallary_description: Number(res.data.data.show_gallary_description),
                        full_width_gallary: Number(res.data.data.full_width_gallary)
                    });

                    }

                })
                .catch(err => console.log(err))
                .finally(() => (this.$parent.loading = false));


        },
        clearForm() {
            this.display_form = 0;
            this.edit = false;
            this.opinion.opinion_id = null;
            this.opinion.name = [];
            this.opinion.show_benefit = 0;
            this.opinion.show_editor = 0;
            this.opinion.show_gallary_description= 0;
            this.opinion.full_width_gallary= 0;
            

        },
        sorting(sortBy) {
            this.sortBy = sortBy;
            this.sortType = this.sortType == 'asc' || this.sortType == 'ASC' ? this.sortType = 'desc' : this.sortType = 'asc';
            this.fetchopinions();
        },
        setSelectedLanguage(selectedLanguage) {
            this.selectedLanguage = selectedLanguage;
        },
        clearSearch() {
            this.searchParameter = "",
                this.fetchopinions();
        },

        setUploadImage() {
            this.opinion.show_upload_image = !this.opinion.show_upload_image;
        }
    },
    mounted() {

        var token = localStorage.getItem('token');
        this.token = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        };
        this.fetchopinions();
        this.fetchLanguages();
    }
};
</script>
